
import sDemoSampleList from './sample/list.vue'
import sDemoSampleForm from './sample/form.vue'


let ServiceRouter = [
  {
    path: '/main/service/serviceDemo/sample/list',
    name: 'sDemoSampleList',
    component: sDemoSampleList
  }, {
    path: '/main/service/serviceDemo/sample/form',
    name: 'sDemoSampleForm',
    component: sDemoSampleForm
  }
]

export default ServiceRouter
